<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title"><img alt="" class="imagelarge_intext" id="fig-4" src="images/fig_2.jpg"/></h1>
<p class="auteur"><img alt="Illustration" class="image_intext" id="fig-005_14" src="images/BG_block_paul_color.jpg"/></p>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre4">Abbreviations</a></div>
<div class="SOM_chap"><a href="#/chap1">1 Retrospective: The New Perspective on Paul</a></div>
<div class="SOM_chap"><a href="#/chap2">2 The Sanders Revolution</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 Climbing the Wright Mountain</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 Dunn, with Paul and the Boundary Markers</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 The New Apocalyptic Paul</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">6 Other Voices, Other Views: Barclay and Chester</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">7 Conclusions: An Appalling Amount of Paul?</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>Voices and Views on Paul</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?854bfdee